export default __webpack_public_path__ + "static/media/acceptworkorder.930badbb.svg";